// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__lEzOM","inner":"Footer_inner__2qqIl"};